import React, { useState, useEffect, useContext } from 'react';
import { Card, Button, Table } from 'react-bootstrap';
import { getFromAPI, deleteFromAPI, showAlert, putToAPI, formatISODateWithTimezone } from '../../../../Utils/utils';
import { toast } from 'react-toastify';
import FormModal from '../../../../Utils/FormModal';

//Icon
import Icon from '@mdi/react';
import { mdiSquareEditOutline, mdiTrashCanOutline } from '@mdi/js';
import { FestivalLeaveContxt } from './festivalLeaveContext';
import { FestivalLeaveProvider, useLeave } from './getfestivalLeave';
import messages from '../../../../Utils/lang';

export default function ViewFestivalLeave({ setSelectedFestivalId }) {
    const selectedFestivalId = useContext(FestivalLeaveContxt);
    const date = new Date();
    const futureDate = date.getDate();
    date.setDate(futureDate);
    const defaultValue = date.toLocaleDateString('en-CA');
    const isAdmin = Number(localStorage.getItem('admin'));
    const initialInputData = {
        holiday_name: '',
        start_date: '',
        end_date: '',
        description: '',
        isdeleted: 0,
        created_date: formatISODateWithTimezone(new Date()),
        last_modified_date: formatISODateWithTimezone(new Date()),
        created_user_id: 1,
        last_modified_user_id: 1,
        reserve_varchar: 'NA',
        reserve_float: 0.0,
        reserve_int: 0,
        reserve_double1: 0.0,
        reserve_date1: new Date().toISOString().split('T')[0],
    };

    const { getFestivalLeave, fetchFestivalLeave } = useLeave();
    const [leaveInputData, setLeaveInputData] = useState(initialInputData);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const fetchFestivalData = async () => {
            try {
                const response = await getFromAPI(`FtsFestivalLeave/?id=${selectedFestivalId}`);
                if (response && response.length > 0) {
                    const fetchedData = response[0];
                    setLeaveInputData({
                        holiday_name: fetchedData.holiday_name,
                        start_date: fetchedData.start_date,
                        end_date: fetchedData.end_date,
                        description: fetchedData.description,
                        isdeleted: fetchedData.isdeleted,
                        created_date: fetchedData.created_date,
                    });

                }
            } catch (error) {
                return null;
            }
        };
        if (selectedFestivalId) {
            fetchFestivalData();
        }
    }, [selectedFestivalId]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };
    
    const fetchLeaveTableData = async () => {
        try {
            const response = await getFromAPI(`FtsFestivalLeave/?id=${selectedFestivalId}`);
            const mappedData = [
                { accountheading: "Festival Name:", accountSubtext: response[0].holiday_name },
                { accountheading: "Start Date:", accountSubtext: formatDate(response[0].start_date) },
                { accountheading: "End Date:", accountSubtext: formatDate(response[0].end_date) },
                { accountheading: "Description:", accountSubtext: response[0].description },
                { accountheading: "Created Date:", accountSubtext: formatDate(response[0].created_date) },
            ];
            setTableData(mappedData)
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        fetchLeaveTableData();
    }, [selectedFestivalId]);

    const handleDelete = async (Id) => {
        try {
            showAlert('Are you sure you want to delete this festival?', 'confirm', (result) => {
                if (result) {
                    // User confirmed the deletion
                    handleDeleteLeave(Id);
                } else {
                    // User canceled the deletion
                }
            });
        } catch (error) {
            toast.error('Error deleting Festival Leave');
        }
    };

    const handleDeleteLeave = async (itemId) => {
        try {
            const response =  await deleteFromAPI(`FtsFestivalLeave/${itemId}/`);
            if(response){         
            toast.success(messages.festivalLeave.deleted);
            
            // Refresh the festival leave list first
            fetchFestivalLeave();
            // After fetching, update the selected festival
            if (getFestivalLeave.length > 0) {
            
               // Select the first festival in the updated list
                setSelectedFestivalId(getFestivalLeave[0].id);
            } else {
                setSelectedFestivalId('');
            }
            
            // Refresh the table data
            setTableData([]);
        }
        } catch (error) {
            toast.error('Error deleting festival leave');
        }
        fetchFestivalLeave();
    };

    const handleSaveChanges = async () => {
        if (!leaveInputData.holiday_name.trim()) {
            toast.error(messages.festivalLeave.required_holiday_name);
            return;
        }
        if (!leaveInputData.start_date || !leaveInputData.end_date) {
            toast.error(messages.festivalLeave.required_date);
            return;
        }
        if (leaveInputData.start_date > leaveInputData.end_date) {
            toast.error(messages.festivalLeave.invalid_date_range);
            return;
        }
        if (!leaveInputData.description.trim()) {
            toast.error(messages.festivalLeave.required_description);
            return;
        }

        const trimmedHolidayName = leaveInputData.holiday_name.trim().toLowerCase();
        const selectedFestivalIdInt = parseInt(selectedFestivalId, 10); // Ensure it's an integer

        const isExists = Array.isArray(getFestivalLeave) && getFestivalLeave.find(leave =>
            leave.holiday_name.trim().toLowerCase() === trimmedHolidayName &&
            leave.id !== selectedFestivalIdInt // Exclude the current record by ID
        );

        if (isExists) {
            toast.error(messages.festivalLeave.already_exist);
            return;
        }
        
        try {
            const response = await putToAPI(`FtsFestivalLeave/${selectedFestivalId}/`, leaveInputData);
            if (response) {
                toast.success(messages.festivalLeave.updated_successfully);
                handleFormModalClose();
                fetchLeaveTableData();
                fetchFestivalLeave();
            }
        } catch (e) {
            toast.error('Error updating festival leave');
            console.error('Error updating festival leave:', e);

        }
    };

    useEffect(() => {
        fetchFestivalLeave();
    }, [selectedFestivalId]);

    const [formModalShow, setShowFormModal] = useState(false);
    const handleLeaveModalEdit = () => setShowFormModal(true);
    const handleFormModalClose = () => setShowFormModal(false);

    const handleInputChange = (index, field, value) => {
        setLeaveInputData({ ...leaveInputData, [field]: value });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setShowFormModal();
    };

    const rows = [
        {
            columns: [
                { size: { lg: 6 }, label: "Festival Name", type: "text", name: "holiday_name", id: "holiday_name", placeholder: "Enter Festival Name", value: leaveInputData.holiday_name, onChange: e => setLeaveInputData({ ...leaveInputData, name: e.target.value }), errormsg: '', },
                { size: { lg: 6 }, label: "Start Date", type: "date", name: "start_date", id: "start_date", placeholder: "DD/MM/YYYY", value: leaveInputData.start_date, onChange: e => setLeaveInputData({ ...leaveInputData, start_date: e.target.value }), errormsg: '', },
                { size: { lg: 6 }, label: "End Date", type: "date", name: "end_date", id: "end_date", placeholder: "DD/MM/YYYY", value: leaveInputData.end_date, onChange: e => setLeaveInputData({ ...leaveInputData, end_date: e.target.value }), errormsg: '', },
                { size: { lg: 6 }, label: "Description", type: "text", name: "description", id: "description", placeholder: "Enter Festival Description", value: leaveInputData.description, onChange: e => setLeaveInputData({ ...leaveInputData, description: e.target.value }), errormsg: '', },

            ]
        }
    ];

    const Buttons = [
        { variant: "primary", text: "Save Changes", onClick: handleSaveChanges },
        { variant: "secondary", text: "Close", onClick: handleFormModalClose },
    ]

    return (
        <>
            <Card className='right-content-details'>
                <Card.Body>
                    <div className='d-flex justify-content-between align-items-center mb-3'>
                        <Card.Title className='mb-0'>View Details</Card.Title>
                        { isAdmin == 1 && (
                        <div>
                            <Button variant='soft-info p-0 me-3' onClick={handleLeaveModalEdit} disabled={!selectedFestivalId}>
                                <div className='avatar avatar-sm'>
                                    <Icon path={mdiSquareEditOutline} className='avatar-icon' />
                                </div>
                            </Button>
                            <Button variant="soft-danger p-0" onClick={() => handleDelete(selectedFestivalId)} disabled={!selectedFestivalId}>
                                <div className='avatar avatar-sm'>
                                    <Icon path={mdiTrashCanOutline} className='avatar-icon' />
                                </div>
                            </Button>
                        </div>
                        )}
                    </div>
                    <Table responsive className='table-lg border mb-0'>
                            <tbody>
                                {tableData.map((data, i) =>
                                    <tr key={i}>
                                        <td style={{ fontWeight: "bold", color: "#383E4B",font : "15px" }} className="w-25">{data.accountheading}</td>
                                        <td className="w-75 text-wrap">{data.accountSubtext}</td>
                                    </tr>
                                )}
                            </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/*Form Modal */}
            <FormModal title="Edit Festival" formModalShow={formModalShow} Buttons={Buttons} handleFormModalClose={handleFormModalClose} rows={rows} handleInputChange={handleInputChange} handleSubmit={handleSubmit} />
        </>

    )

}
